import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SetModale } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-modal',
  templateUrl: './sample-modal.component.html',
  styleUrls: ['./sample-modal.component.scss']
})
export class SampleModalComponent implements OnInit {

  @Input() block: SetModale[] = [];
  public domainWebsite = environment.urlApi;
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.helpersService.viewportScroll(event);
  }

  constructor(public helpersService: HelpersService) { }

  ngOnInit(): void {}

}
